import { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  alpha,
  Popover,
  Typography,
  styled
} from '@mui/material';

import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import AuthService from 'src/services/AuthService';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from "../../../../redux/userRedux";

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding: ${theme.spacing(0.6, 1.2)};
        border-radius: ${theme.general.borderRadiusLg};
        color: ${theme.colors.alpha.black[100]};
        transition: background-color .15s ease;

        &:hover {
          background-color: ${theme.colors.alpha.black[5]};
        }
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: 600;
        font-size: ${theme.typography.pxToRem(14)};
        color: ${theme.colors.alpha.black[100]};
        display: block;
        line-height: 1.3;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${theme.colors.alpha.black[50]};
        font-size: ${theme.typography.pxToRem(12)};
`
);

function HeaderUserbox() {
  const user = {
    name: 'Harsha Gunathilake',
    avatar: '/static/images/avatars/3.jpg',
    jobtitle: 'Project Manager'
  };

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = (e: any) => {
    e.preventDefault();
    AuthService.logout()
      .then((response: any) => {
          dispatch(logout());
          navigate("/");
      })
      .catch((e: Error) => {
        console.log(e.message);
      });
  };

  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  const capitalizeFirstLetter = (string : any) => {
    return string?.charAt(0).toUpperCase() + string?.slice(1);
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar
          variant="rounded"
          alt={capitalizeFirstLetter(loggedInUser?.username)}
          src={user.avatar}
          sx={{ width: 34, height: 34, borderRadius: 2 }}
        />
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{capitalizeFirstLetter(loggedInUser?.username)}</UserBoxLabel>
            {/* <UserBoxDescription variant="body2">
              {user.jobtitle}
            </UserBoxDescription> */}
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon
            sx={{ ml: 1, color: (theme) => theme.colors.alpha.black[50] }}
          />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: 3,
            boxShadow: '0px 8px 24px rgba(15, 23, 42, 0.10), 0px 2px 8px rgba(15, 23, 42, 0.06)',
            border: (theme) => `1px solid ${theme.colors.alpha.black[10]}`
          }
        }}
      >
        <MenuUserBox sx={{ minWidth: 220 }} display="flex">
          <Avatar
            variant="rounded"
            alt={loggedInUser?.username}
            src={user.avatar}
            sx={{ width: 40, height: 40, borderRadius: 2 }}
          />
          <UserBoxText>
            <UserBoxLabel variant="body1">{capitalizeFirstLetter(loggedInUser?.username)}</UserBoxLabel>
            {loggedInUser?.role && (
              <UserBoxDescription variant="body2">
                {capitalizeFirstLetter(loggedInUser?.role)}
              </UserBoxDescription>
            )}
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <Box sx={{ m: 1 }}>
          <Button
            color="secondary"
            fullWidth
            onClick={handleNavigate}
            sx={{
              justifyContent: 'flex-start',
              color: (theme) => theme.palette.error.main,
              '&:hover': {
                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08)
              }
            }}
          >
            <LockOpenTwoToneIcon sx={{ mr: 1 }} fontSize="small" />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
